/**
 * Centralized route definitions and utilities
 * Provides type-safe route generation and eliminates hardcoded route strings
 * 
 * Usage Examples:
 * 
 * // Simple navigation
 * setLocation(ROUTES.HOME());
 * 
 * // Navigation with parameters
 * setLocation(ROUTES.RECIPE(recipeId));
 * setLocation(ROUTES.RECIPE_EDIT(recipeId));
 */

// Unified route interface - all routes as functions for consistency
export const ROUTES = {
  // Static routes (no parameters)
  HOME: (): string => "/",
  LANDING: (): string => "/",
  HELP: (): string => "/help",
  HOUSEHOLD: (): string => "/household",
  AI_CHEF: (): string => "/ai-chef",
  RECIPES_BASE: (): string => "/recipes",
  RECIPES_NEW: (): string => "/recipes/new",
  RECIPE_GROUPS_BASE: (): string => "/recipe-groups",
  SHARED_BASE: (): string => "/shared",
  PREVIEW_BASE: (): string => "/preview",
  
  // Dynamic routes (with parameters)
  RECIPE: (id: string): string => `/recipes/${id}`,
  RECIPE_EDIT: (id: string): string => `/recipes/${id}/edit`, 
  RECIPE_GROUP: (id: string): string => `/recipe-groups/${id}`,
  SHARED_RECIPE: (token: string): string => `/shared/${token}`,
  RECIPE_PREVIEW: (url: string): string => `/preview/${encodeURIComponent(url)}`,
} as const;

// Type definitions for route parameters
export interface RouteParams {
  recipeId: string;
  groupId: string;
  token: string;
  jobId: string;
}

// Utility functions
